import Vue from 'vue';
// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultSubstantiveUserPagination = {
	total: 100,
	$skip: 0,
	$limit: 10,
};
const defaultSubstantiveUserFilter = {
	$skip: defaultSubstantiveUserPagination.$skip,
	$limit: defaultSubstantiveUserPagination.$limit,
};
export default {
	state: {
		substantiveUser: [],
		substantiveUserPagination: defaultSubstantiveUserPagination,
		SubstantiveUserFilter: defaultSubstantiveUserFilter,
	},
	getters: {
		setsubstantiveUserPage: (state) => {
			const { $limit, $skip } = state.substantiveUserPagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_SUBSTANTIVE_USER: (state, data) => { state.substantiveUser = data; },
		SET_SUBSTANTIVE_USER_PAGINATION: (state, data) => { state.substantiveUserPagination = {...state.substantiveUserPagination, ...data};},
		SET_SUBSTANTIVE_USER_FILTER: (state, filter) => { state.SubstantiveUserFilter = { ...state.SubstantiveUserFilter, ...filter }; },
		SET_SUBSTANTIVE_USER_PERMISSION: (state, substantiveUserPermission) => { state.substantiveUserPermission = substantiveUserPermission; },
	},
	actions: {
		setSubstantiveUserFilter: ({ commit }, filter) => {
			commit('SET_SUBSTANTIVE_USER_FILTER', filter);
		},
		setsubstantiveUserListPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.substantiveUserPagination.$limit;
			commit('SET_SUBSTANTIVE_USER_PAGINATION', { $skip });
			commit('SET_SUBSTANTIVE_USER_FILTER', { $skip });
		},
		getAllSubstantiveUserForTrust: async({ rootGetters, commit }, filter) => {
			const results = await feathersClient.service('api/v3/substantive-joiners').find({
				query: {
					$role: rootGetters.currentUserRole,
					fields: ['bands'],
					...filter,

				},
			});
			commit('SET_SUBSTANTIVE_USER', results.data);
			commit('SET_SUBSTANTIVE_USER_PAGINATION', { total: results.total });
			return results.data;
		},
		updateSubstantiveUserForTrust: async({ rootGetters, commit }, data) => {
			const results = await feathersClient.service('/api/v3/substantive-joiners').patch(data.id, data, {
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
	},
};
